export default {
  tiny: '4px',
  xsmall: '8px',
  small: '12px',
  normal: '16px',
  medium: '24px',
  large: '30px',
  xlarge: '48px'
};
//# sourceMappingURL=spacings.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-misc/lib/styles/spacings.js
// module id = 800
// module chunks = 0